import { ReplaySubject } from 'rxjs/ReplaySubject';
export var createFileStateSubject = function (initialState) {
    var subject = new ReplaySubject(1);
    if (initialState) {
        subject.next(initialState);
    }
    return subject;
};
//# sourceMappingURL=createFileStateSubject.js.map